import { PropsWithChildren, useEffect } from 'react'
import { useRouter } from 'next/router'

import Typography from '@/components/base/typography'
import Spacer from '@/components/sections/spacer'
import { useStore } from '@/contexts/store'
import { useLocaleStore } from '@/store/locale'
import { useRouterStore } from '@/store/router'

import { cn } from '@/lib/utils'
import { WPPageData } from '@/types'

type MetaProps = {
  pageProps?: WPPageData
}

export type LayoutProps = PropsWithChildren & MetaProps

const Layout = ({ children, pageProps }: LayoutProps) => {
  const { strings } = useStore()
  const { footer } = strings || {}
  const router = useRouter()
  const setCurrentRoute = useRouterStore((state) => state.setCurrentRoute)
  const setCurrentLocale = useLocaleStore((state) => state.setCurrentLocale)
  const setCurrentTranslations = useLocaleStore(
    (store) => store.setCurrentTranslations
  )

  useEffect(() => {
    setCurrentRoute(router.asPath)
    setCurrentLocale(router.locale)
  }, [router.asPath, setCurrentRoute])

  useEffect(() => {
    setCurrentTranslations(pageProps?.wpml_translations || [])
  }, [pageProps])

  return (
    <div className="pb-[80px] pt-header-height md:pb-0">
      {children}

      <Spacer variant="xxl" />
      <div className="flex w-full justify-center px-[4rem] py-[3.6rem]">
        <Typography
          className={cn(
            'text-center text-[16px] tracking-[0.0384rem]',
            'text-white'
          )}
          data-motion-colophon
        >
          {footer?.colophon_ads}
        </Typography>
      </div>
    </div>
  )
}

export default Layout
